import { useTheme } from '@mui/material';
import React from 'react';

const HourGlassTheme: React.FC = (props: any) => {
	const {
		palette: {
			illustrationAccent,
			primary: { dark: primaryDark, light: primaryLight }
		}
	} = useTheme();

	return (
		<svg
			width="300"
			height="300"
			viewBox="0 0 300 300"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M200.287 194.961C193.263 186.724 170.663 159.728 163.121 151.962C179.574 137.336 228.761 90.9191 228.761 58.2901C228.745 62.7676 196.995 66.4078 157.826 66.4078C118.656 66.4078 86.908 62.775 86.8885 58.2886C86.8885 90.9146 136.077 137.346 152.53 151.964C144.989 159.73 123.313 185.601 116.288 193.836"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M95.2875 226.085C90.028 236.423 86.8871 246.3 86.8871 254.827"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M116.258 193.864C110.429 201.479 100.211 217.857 95.2875 226.086"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M228.761 254.83C228.761 237.496 214.881 214.32 199.392 193.864"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M95.5092 258.715C90.0676 257.573 86.9512 256.266 86.8885 254.875V257.718C86.8885 259.124 90.0228 260.445 95.5092 261.598V258.715Z"
				fill={illustrationAccent} // used to be secondary main
			/>
			<path
				d="M155.172 263.265C130.488 263.265 108.642 260.811 95.2875 258.711V261.336C108.642 263.438 130.486 266.211 155.175 266.211C195.822 266.211 228.77 262.496 228.787 257.913V254.961C228.787 259.542 195.828 263.265 155.172 263.265Z"
				fill={illustrationAccent} // used to be secondary main
			/>
			<path
				d="M96.0375 258.336C90.5959 257.194 86.9512 256.266 86.8885 254.875V257.718C86.8885 259.124 94.6761 261.307 100.163 262.461"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M100.117 262.439C112.985 264.495 134.035 265.836 157.826 265.836C196.995 265.836 228.745 262.201 228.761 257.718V254.83C228.761 259.316 197.001 262.954 157.823 262.954C134.037 262.954 112.985 261.61 100.117 259.555"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M157.826 63.5255C118.649 63.5255 86.8885 59.8883 86.8885 55.4033V58.2898C86.905 62.7673 118.655 66.4075 157.826 66.4075C196.996 66.4075 228.745 62.7733 228.761 58.2883V55.4332C228.622 59.9047 196.917 63.5255 157.826 63.5255Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M157.826 47.2812C118.649 47.2812 86.8885 50.917 86.8885 55.4034C86.8885 59.8899 118.649 63.5256 157.826 63.5256C197.002 63.5256 228.763 59.8884 228.763 55.4034C228.763 50.9185 197.004 47.2812 157.826 47.2812Z"
				fill={illustrationAccent} // used to be secondary main
			/>
			<path
				d="M157.826 47.2812C118.649 47.2812 86.8885 50.917 86.8885 55.4034C86.8885 59.8899 118.649 63.5256 157.826 63.5256C197.002 63.5256 228.763 59.8884 228.763 55.4034C228.763 50.9185 197.004 47.2812 157.826 47.2812Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M152.53 151.963V194.585H163.127V151.962C175.714 140.795 187.554 128.814 198.571 116.096C179.168 116.421 169.191 124.203 151.432 126.819C142.615 128.236 133.591 127.631 125.041 125.051C135.92 136.831 146.456 146.564 152.53 151.963Z"
				fill={primaryLight}
			/>
			<path
				d="M102.037 230.21C94.0702 237.003 88.883 245.208 87.0375 253.936C87.0375 255.668 92.4746 258.42 102.037 259.835V230.21Z"
				fill={primaryLight}
			/>
			<path
				d="M214.108 235.736C212.664 219.799 202.812 215.901 187.444 220.364C187.161 218.059 186.514 215.815 185.528 213.713C184.927 212.362 183.912 211.236 182.63 210.5C181.347 209.763 179.864 209.454 178.394 209.616C177.418 209.724 176.476 210.035 175.63 210.531C170.773 212.665 166.486 215.91 163.113 220.005V193.864H152.53V220.813C149.679 216.355 145.614 212.903 140.336 212.531C137.687 212.365 135.036 212.81 132.586 213.831C130.136 214.852 127.953 216.421 126.205 218.419C120.138 225.48 122.271 223.972 114.376 225.022C109.161 225.678 104.228 227.758 100.118 231.033V259.555C112.986 261.612 134.038 262.954 157.824 262.954C197.002 262.954 228.763 259.316 228.763 254.83C226.467 241.239 215.609 249.264 214.108 235.736Z"
				fill={primaryLight}
			/>
			<path
				d="M99.7875 231.335C95.2079 236.857 87.9479 247.735 86.8871 254.83C86.8871 256.237 94.2907 258.31 99.7875 259.46"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M163.121 193.837V151.962C175.71 140.795 187.552 128.814 198.571 116.096C179.168 116.421 169.191 124.203 151.432 126.819C142.615 128.236 133.591 127.631 125.041 125.051C135.92 136.83 146.456 146.562 152.53 151.96V193.835"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M152.53 193.864V220.813C149.679 216.355 145.614 212.903 140.336 212.531C137.687 212.365 135.036 212.81 132.586 213.831C130.136 214.852 127.953 216.421 126.205 218.419C120.138 225.48 122.271 223.972 114.376 225.022C109.161 225.678 104.228 227.758 100.118 231.033"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M100.117 259.555C112.985 261.612 134.037 262.954 157.823 262.954C197.001 262.954 228.761 259.316 228.761 254.83C226.467 241.239 215.609 249.264 214.114 235.736C212.67 219.799 202.818 215.901 187.45 220.364C187.167 218.059 186.52 215.815 185.534 213.713C185.135 212.816 184.551 212.014 183.821 211.359C183.09 210.704 182.23 210.21 181.295 209.91C180.361 209.611 179.374 209.511 178.399 209.618C177.424 209.725 176.483 210.036 175.636 210.531C170.779 212.665 166.492 215.91 163.119 220.005V193.864"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M173.734 113.49C156.919 114.233 140.396 118.155 125.041 125.051C144.49 131.133 160.626 125.009 174.701 120.514C183.379 117.745 189.549 116.26 198.571 116.1C192.317 112.912 179.819 113.144 173.734 113.489V113.49Z"
				fill={primaryLight}
			/>
			<path
				d="M173.734 113.49C156.919 114.233 140.396 118.155 125.041 125.051C144.49 131.133 160.626 125.009 174.701 120.514C183.379 117.745 189.549 116.26 198.571 116.1C192.317 112.912 179.819 113.144 173.734 113.489V113.49Z"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M71.0919 153.867L90.0049 151.135"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M251.191 107.206L233.629 114.739"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M71.0636 142.539L90.0333 144.827"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M254.15 118.141L235.234 120.84"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M69.0114 204.293H83.2379"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M76.1246 211.407V197.179"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M46.5 237.017H54.2595"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M50.3805 240.897V233.136"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M228.787 175.46L238.847 185.52"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M228.787 185.52L238.847 175.46"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M98.0674 37.3335L102.466 44.5885L107.639 33.75"
				stroke={primaryDark}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default HourGlassTheme;
